<template>
	<BaseCmsPage v-slot="{page}">
		<h1 style="display: none;">{{ page?.seo_h1 }}</h1>
		<AuthLoginRegisterLayout>
			<template #col1>
				<BaseCmsLabel class="auth-login-title" code="login_to_account" tag="h2" />
				<div class="auth-login-subtitle"><BaseCmsLabel code="social_login" /></div>
				<AuthLoginForm mode="login" />
			</template>
			<template #col2>
				<div v-if="page?.content" class="cms-content login-content" v-html="page.content" ref="content" v-interpolation />
				<BaseAuthUser v-slot="{urls}">
					<NuxtLink :to="urls.auth_signup" class="btn btn-login-register">
						<BaseCmsLabel code="create_account" />
					</NuxtLink>
				</BaseAuthUser>
				<AuthLoginRegisterBenefits mode="login" />
			</template>
		</AuthLoginRegisterLayout>
	</BaseCmsPage>
</template>

<script setup>
</script>

<style scoped lang="less">
	h2,:deep(h2){
		font-size: 25px; padding-bottom: 12px;
		@media (max-width: @m){font-size: 18px; padding-bottom: 7px;}	
	}
	.auth-login-subtitle{
		display: block; font-size: 12px; line-height: 1.2; font-weight: 700; color: var(--darkGray); margin: 6px 0 12px;
		@media (max-width: @m){margin: 0 0 12px;}	
	}

	//col2
	.login-content{
		padding-top: 72px; font-size: 14px; line-height: 23px;
		:deep(p){padding:  0 0 16px;}
		@media (max-width: @t){padding-top: 24px;}
		@media (max-width: @m){
			padding-top: 0; font-size: 13px; line-height: 1.4;
			:deep(p){padding: 0 0 14px;}	
		}
	}
	.btn-login-register{
		width: 265px;
		@media (max-width: @m){width: 100%;}	
	}
</style>